<aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme">
  <!-- Menu principal -->
  <ul class="menu-inner">
    <ng-container *ngFor="let un_menu of api.menu">
      <li class="menu-header small text-uppercase text-muted py-2 px-4">
        <span class="menu-header-text">{{ un_menu.menu_header }}</span>
      </li>
      <li *ngFor="let un_item of un_menu.items" class="menu-item" 
          [routerLinkActive]="'active'" 
          [routerLinkActiveOptions]="un_item.text === 'Pointage' ? { exact: true } : { exact: false }">
        <a [routerLink]="[un_item.path]" class="menu-link rounded-start">
          <i class="menu-icon tf-icons bx" [class]="un_item.icone"></i>
          <div data-i18n="Analytics" class="ms-2">{{ un_item.text }}</div>
        </a>
      </li>
    </ng-container>
  </ul>

  <!-- Utilisateurs en ligne -->
  <div class="mt-auto">
    <li class="menu-item border-top" style="background-color: #f5f5f9;">
      <a href="javascript:void(0);" class="menu-link menu-toggle p-0">
        <img src="../assets/img/logo_jb.png" alt="Avatar" class="w-px-40 h-auto rounded-circle">
        <div class="text-truncate fw-semibold text-dark" data-i18n="Layouts">
          {{ api.les_utilisateurs.length }} • connecté{{ api.les_utilisateurs.length > 1 ? 's' : '' }}
        </div>
      </a>
      <ul class="menu-sub">
        <li *ngFor="let un_utilisateur of api.les_utilisateurs" class="menu-item clique">
          <a class="menu-link py-1 px-2">
            <i class="bi" [ngClass]="{'bi-laptop':un_utilisateur?.data_parsed?.device!='mobile','bi-phone':un_utilisateur?.data_parsed?.device=='mobile'}"></i>
            <div class="text-truncate ms-2" [title]="un_utilisateur?.titre">{{ un_utilisateur?.titre }}</div>
          </a>
        </li>
      </ul>
    </li>
  </div>
</aside>